import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'

import {
  Desktop,
  Tablet,
  Mobile
} from './Responsive'

export default class Breakpoint extends Component {
  static propTypes = {
    children: PropTypes.func.isRequired
  }

  render() {
    const {
      children,
      ...rest
    } = this.props

    return (
      <Fragment>
        <Desktop>
          {children({ ...rest, breakpoint: 'lg' })}
        </Desktop>

        <Tablet>
          {children({ ...rest, breakpoint: 'md' })}
        </Tablet>

        <Mobile>
          {children({ ...rest, breakpoint: 'sm' })}
        </Mobile>
      </Fragment>
    )
  }
}
